import { render, staticRenderFns } from "./onInpt.vue?vue&type=template&id=28ed00da"
import script from "./onInpt.vue?vue&type=script&lang=js"
export * from "./onInpt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports